import { useState, useEffect } from "react";
import {
  Box,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { UseOrders } from "../OrdersPage/UseOrders";
import ProgressCom from "../../components/ProgressCom";
import UserInf from "./UserInf";
import SendInformation from "./SendInformation";
import OrderPayMent from "./OrderPayMent";
import OrdersList from "./OrdersList";
import InfoGraphy from "./InfoGraphy";
import Operation from "./Operation";
import { rsActiveMenu, rsAddress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import ArrowCircleLeftRoundedIcon from "@mui/icons-material/ArrowCircleLeftRounded";
import { useSearchParams } from "react-router-dom";

export default function OrderDetail() {
  const [msAddress, setMsAddress] = useRecoilState(rsAddress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [orderDetail, setOrderDetail] = useState();
  const [reload, setReload] = useState(false);
  const { getOrderByID } = UseOrders();
  const [expanded, setExpanded] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [orderState, setOrderState] = useState(
    searchParams && searchParams.get("oid") ? searchParams.get("oid") : ""
  );

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    const element = document.getElementById("panel1");
    setTimeout(() => {
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 500);
  };

  useEffect(() => {
    setMsAddress(false);
    if (orderState) {
      getOrderByID(orderState, (orderRes) => {
        setOrderDetail(orderRes);
      });
    }
  }, []);

  useEffect(() => {
    setMsAddress(false);
    if (reload == true) {
      getOrderByID(orderState, (orderRes) => {
        setReload(false);
        setOrderDetail({
          ...orderDetail,
          province: orderRes.province,
          city: orderRes.city,
          neighbourhood: orderRes.neighbourhood,
          deliveryTime: orderRes.deliveryTime,
          deliveryType: orderRes.deliveryType,
          deliveryTypeID: orderRes.deliveryTypeID,
          postCode: orderRes.postCode,
          address: orderRes.address,
          postFollowupCode: orderRes.postFollowupCode,
          latitude: orderRes.latitude,
          longitude: orderRes.longitude,
        });
      });
    }
  }, [reload]);

  return (
    <Detail
      breadChilds={{
        normargin: true,
        backButtonOrders: {
          state: location.state,
          replace: true,
        },
        title: "سفارشات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/orders",
          },
          {
            name: "جزئیات سفارش" + " (" + orderState + ")",
            // url: `/orders/orderDetail?oid=${orderState}`,
          },
        ],
      }}
    >
      {orderDetail ? (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            <UserInf
              orderDetail={orderDetail}
              setOrderDetail={setOrderDetail}
              setReload={setReload}
            />
            <SendInformation
              orderDetail={orderDetail}
              setOrderDetail={setOrderDetail}
              setReload={setReload}
            />
            <OrderPayMent
              orderDetail={orderDetail}
              setOrderDetail={setOrderDetail}
              orderState={location.state?.orderState}
              setReload={setReload}
            />
            <OrdersList
              orderDetail={orderDetail}
              setOrderDetail={setOrderDetail}
              setReload={setReload}
            />
            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
              style={{
                p: 2,
                m: 2,
              }}
            >
              <AccordionSummary
                // onClick={() => setExpanded("panel2")}
                // expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <ArrowCircleLeftRoundedIcon
                    sx={{ mr: 1 }}
                    color="secondary"
                    // fontSize="small"
                  />
                  <Typography variant="subtitle1" color="secondary">
                    اینفوگرافی پروسه خرید
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails id="panel1">
                <InfoGraphy
                  orderDetail={orderDetail}
                  setOrderDetail={setOrderDetail}
                  setReload={setReload}
                />
              </AccordionDetails>
            </Accordion>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
            }}
          >
            <Operation
              orderState={location.state?.orderState}
              orderFilter={location.state?.orderFilter}
              orderDetail={orderDetail}
              setOrderDetail={setOrderDetail}
              setReload={setReload}
            />
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
